import React, { Fragment, PureComponent } from "react"
import {
  BarChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  PieChart,
  Pie,
  Cell
} from "recharts"

import Loader from "./../../Loader/Loader.js"
import {
  Metric,
  selectFormat,
  StandardTooltip,
  
} from "./../../Utils/Utils.js"


import Heading from "./../../Elements/Heading"

const color = {
  views: '#FC6D52',
  unique_viewers: '#007bff',
  minutes_watched: '#28a745',
  minutes_watched_per_video: '#e83e8c'
}

const COLORS = [
  '#FC6D52',
  '#f4f4f4'
];

class InstagramVideoKeyStats extends PureComponent {
  render() {
    const { loading } = this.props

    if (loading) {
      return <Loader minHeight={340} col={"col-12 col-md-6"} />
    }

    const data = this.props.data
    // const goal = data.per_brand

    data.metrics.views.paid = data.metrics.views.paid || 0;
    data.metrics.views.paid = [{value: 100 * data.metrics.views.paid}, {value: 100 * (1 - data.metrics.views.paid)}]
    
    return (
      <div className="row key-stats border-between-metrics">
        
        <div className="col-lg-3 col-sm-6 col-12 key-stats--item">
          <div className="row row--header">
            <div className="col-7">
              <Heading size={5}>Total Views</Heading>
              <Metric {...data.metrics.views} size={"md"} />

              <div className="row pie-metric align-items-center">
                <div className="col-6">
                  <PieChart height={45} width={45}>
                    <Pie dataKey="value" data={data.metrics.views.paid} outerRadius="100%" innerRadius="75%" startAngle={450} endAngle={90}>
                      {
                        data.metrics.views.paid.map((entry, index) => (
                          <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                        ))
                      }
                    </Pie>
                    <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" className="piechart-metric__xsmall">
                      
                      {selectFormat("percentage", data.metrics.views.paid[0].value)}
                    </text>
                  </PieChart>
                </div>
                <div className="col-6">
                  <h6 className="widget__metric-label ml-2 mt-2">Paid</h6>
                </div>
              </div>

            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.views} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>

          <ResponsiveContainer height={230} width="100%" className="mt-5">
            <BarChart data={data.metricsByDay.map(d => ({ date: d.date, value: d.views }))}>
              <Tooltip cursor={{ fill: "#eee", opacity: .5 }} content={
                <StandardTooltip
                  render={({ data }) => {

                    const payload = data(this.props)
                    if (payload !== null) {

                      return (
                        <div className="standard-tooltip">
                          {
                            Object.keys(payload).map(key => (
                              <Fragment key={key}>
                                <header className="standard-tooltip__header">
                                  <span className="standard-tooltip__key-header">
                                    Total Views
                                  </span>
                                </header>
                                <main className="standard-tooltip__main">
                                  <div className="standard-tooltip__item">
                                    <span className="standard-tooltip__key">
                                      <span className="standard-tooltip__icon" style={{ 'background': color.views }}></span>
                                      <span className="standard-tooltip__value-header">
                                        {selectFormat('date', payload[key].payload.date, "MM/DD")}
                                      </span>
                                    </span>
                                    <span className="standard-tooltip__value">
                                        {selectFormat(
                                        "number",
                                        payload[key].value
                                      )}
                                    </span>
                                  </div>
                                </main>
                              </Fragment>
                            ))}
                        </div>
                      )
                    }
                  }} />
              }
              />
              <defs>
                <linearGradient id={`color-${color.views}`} x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor={color.views} stopOpacity={.55} />
                  <stop offset="95%" stopColor={color.views} stopOpacity={1} />
                </linearGradient>
              </defs>
              <Bar dataKey="value" fillOpacity={1} fill={`url(#color-${color.views})`} />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.views} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
        </div>

        { data.metrics.unique_viewers ? (
          <div className="col-lg-3 col-sm-6 col-12 key-stats--item">
            <div className="row row--header">
              <div className="col-7">
                <Heading size={5}>Unique Viewers</Heading>
                <Metric {...data.metrics.unique_viewers} size={"md"} />
              </div>
              {/* {
                goal ? (
                  <div className="col-5 mt-1">
                    <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                    <Metric value={goal.unique_viewers} size={"sm"} icon="line" />
                  </div>
                ) : null
              } */}
            </div>

            <ResponsiveContainer height={230} width="100%" className="mt-5">
              <BarChart data={data.metricsByDay.map(d => ({ date: d.date, value: d.unique_viewers }))}>
                <Tooltip cursor={{ fill: "#eee", opacity: .5 }} content={
                  <StandardTooltip
                    render={({ data }) => {

                      const payload = data(this.props)
                      if (payload !== null) {

                        return (
                          <div className="standard-tooltip">
                            {
                              Object.keys(payload).map(key => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Unique Viewers
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span className="standard-tooltip__icon" style={{ 'background': color.unique_viewers }}></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat('date', payload[key].payload.date, "MM/DD")}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                        "number",
                                        payload[key].value
                                      )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                          </div>
                        )
                      }
                    }} />
                }
                />
                <defs>
                  <linearGradient id={`color-${color.unique_viewers}`} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor={color.unique_viewers} stopOpacity={.55} />
                    <stop offset="95%" stopColor={color.unique_viewers} stopOpacity={1} />
                  </linearGradient>
                </defs>
                <Bar dataKey="value" fillOpacity={1} fill={`url(#color-${color.unique_viewers})`} />
                <XAxis dataKey="date" hide />
                {/* {goal ? <ReferenceLine y={goal.unique_viewers} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
              </BarChart>
            </ResponsiveContainer>
          </div>
      
        ) : null}      
        
        <div className="col-lg-3 col-sm-6 col-12 key-stats--item">
          <div className="row row--header">
            <div className="col-7">
              <Heading size={5}>Minutes Watched</Heading>
              <Metric {...data.metrics.minutes_watched} size={"md"} />
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.minutes_watched} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>

          <ResponsiveContainer height={230} width="100%" className="mt-5">
            <BarChart data={data.metricsByDay.map(d => ({ date: d.date, value: d.minutes_watched }))}>
              <Tooltip cursor={{ fill: "#eee", opacity: .5 }} content={
                <StandardTooltip
                  render={({ data }) => {

                    const payload = data(this.props)
                    if (payload !== null) {

                      return (
                        <div className="standard-tooltip">
                          {
                            Object.keys(payload).map(key => (
                              <Fragment key={key}>
                                <header className="standard-tooltip__header">
                                  <span className="standard-tooltip__key-header">
                                    Minutes Watched
                                  </span>
                                </header>
                                <main className="standard-tooltip__main">
                                  <div className="standard-tooltip__item">
                                    <span className="standard-tooltip__key">
                                      <span className="standard-tooltip__icon" style={{ 'background': color.minutes_watched }}></span>
                                      <span className="standard-tooltip__value-header">
                                        {selectFormat('date', payload[key].payload.date, "MM/DD")}
                                      </span>
                                    </span>
                                    <span className="standard-tooltip__value">
                                    {selectFormat("number", payload[key].value)}
                                      
                                    </span>
                                  </div>
                                </main>
                              </Fragment>
                            ))}
                        </div>
                      )
                    }
                  }} />
              }
              />
              <defs>
                <linearGradient id={`color-${color.minutes_watched}`} x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor={color.minutes_watched} stopOpacity={.55} />
                  <stop offset="95%" stopColor={color.minutes_watched} stopOpacity={1} />
                </linearGradient>
              </defs>
              <Bar dataKey="value" fillOpacity={1} fill={`url(#color-${color.minutes_watched})`} />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.minutes_watched} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
        </div>
      
        <div className="col-lg-3 col-sm-6 col-12 key-stats--item">
          <div className="row row--header">
            <div className="col-7">
              <Heading size={5}>Mins per Video</Heading>
              <Metric {...data.metrics.minutes_watched_per_video} size={"md"} type={"time"} />
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.minutes_watched_per_video} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>

          <ResponsiveContainer height={230} width="100%" className="mt-5">
            <BarChart data={data.metricsByDay.map(d => ({ date: d.date, value: d.minutes_watched_per_video }))}>
              <Tooltip cursor={{ fill: "#eee", opacity: .5 }} content={
                <StandardTooltip
                  render={({ data }) => {

                    const payload = data(this.props)
                    if (payload !== null) {

                      return (
                        <div className="standard-tooltip">
                          {
                            Object.keys(payload).map(key => (
                              <Fragment key={key}>
                                <header className="standard-tooltip__header">
                                  <span className="standard-tooltip__key-header">
                                    Mins per Video
                                  </span>
                                </header>
                                <main className="standard-tooltip__main">
                                  <div className="standard-tooltip__item">
                                    <span className="standard-tooltip__key">
                                      <span className="standard-tooltip__icon" style={{ 'background': color.minutes_watched_per_video }}></span>
                                      <span className="standard-tooltip__value-header">
                                        {selectFormat('date', payload[key].payload.date, "MM/DD")}
                                      </span>
                                    </span>
                                    <span className="standard-tooltip__value">
                                      { ('0' + Math.floor(payload[key].value) % 24).slice(-2) + ':' + ((payload[key].value % 1)*60 + '0').slice(0, 2) }
                                    </span>
                                  </div>
                                </main>
                              </Fragment>
                            ))}
                        </div>
                      )
                    }
                  }} />
              }
              />
              <defs>
                <linearGradient id={`color-${color.minutes_watched_per_video}`} x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor={color.minutes_watched_per_video} stopOpacity={.55} />
                  <stop offset="95%" stopColor={color.minutes_watched_per_video} stopOpacity={1} />
                </linearGradient>
              </defs>
              <Bar dataKey="value" fillOpacity={1} fill={`url(#color-${color.minutes_watched_per_video})`} />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.minutes_watched_per_video} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
        </div>
      
      </div>
    )
  }
}

export default InstagramVideoKeyStats
